import { Controller } from "@hotwired/stimulus";

// Super-admin tenant page (tenants/edit): a quota where 0 means unlimited
// (team members) gets an Unlimited box instead of a typed 0. Ticking it
// empties and disables the number so the two can't disagree; a disabled
// field isn't submitted, and the server stores Unlimited as the plan's own
// "0". Works without JS too — the server treats a ticked box as the answer.
export default class extends Controller {
  static targets = ["number", "unlimited"];

  connect() {
    this.sync();
  }

  sync() {
    const unlimited = this.unlimitedTarget.checked;
    this.numberTarget.disabled = unlimited;
    if (unlimited) this.numberTarget.value = "";
  }
}
